export function formatLabel(label: string) {
  return label
    .toLowerCase()
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export const formatHoursToHoursAndMinutes = (hours: number) => {
  const totalMinutes = hours * 60;
  const hrs = Math.floor(totalMinutes / 60);
  const mins = Math.round(totalMinutes % 60);
  if (hrs && mins) return `${hrs}h ${mins}m`;
  if (hrs) return `${hrs}h`;
  return `${mins}m`;
};

export const formatEnum = (str: string) => {
  if (!str.trim() || typeof str !== "string") return str;

  // return str.replace(
  //   /(^|[_ -]+)(\w)(\w*)/g,
  //   (_, p1, p2, p3) => (p1 ? " " : "") + p2.toUpperCase() + p3.toLowerCase()
  // );

  return str
    .replace(/[_ -]/g, " ")
    .replace(
      /(^|\s)(\w)(\w*)/g,
      (_, p1, p2, p3) => p1 + p2.toUpperCase() + p3.toLowerCase()
    );

  // return str
  //   .replace(/[_ -]/g, " ")
  //   .replace(/(?:^|\s)\w/g, (match) => match.toUpperCase())
  //   .replace(/\w+/g, (word) => word.charAt(0) + word.slice(1).toLowerCase());
  // let strs = str.split(/[_ -]/);

  // let stri = strs
  //   .map((item) => item.charAt(0).toUpperCase() + item.slice(1).toLowerCase())
  //   .reduce((acc, word) => acc + " " + word);

  // return stri;
};
